/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, UserListEntryFromJSON, UserListEntryToJSON, } from './';
export function PagedResponseOfUserListEntryFromJSON(json) {
    return PagedResponseOfUserListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfUserListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'page': !exists(json, 'page') ? undefined : json['page'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(UserListEntryFromJSON)),
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious']
    };
}
export function PagedResponseOfUserListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'page': value.page,
        'totalElements': value.totalElements,
        'hasNext': value.hasNext,
        'nextPage': PageRequestToJSON(value.nextPage),
        'size': value.size,
        'metaData': MetaDataToJSON(value.metaData),
        'numberOfElements': value.numberOfElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(UserListEntryToJSON)),
        'previousPage': PageRequestToJSON(value.previousPage),
        'hasPrevious': value.hasPrevious
    };
}
